import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

interface LoaderProps {
  size: string;
  ratio?: number;
}

const Loader = styled.div<LoaderProps>`
  border: 10px solid rgba(255, 255, 255, 0.3);
  border-top: 10px solid white;
  border-radius: 50%;
  width: ${({ size }) => size};
  aspect-ratio: 1;
  animation: ${spin} 1s linear infinite;
`;

const Spinner = ({ size = '20%' }) => {
  return <Loader size={size} />;
};

export default Spinner;
